export default __webpack_public_path__ + "static/media/grid.ae3bf787.svg";